import * as React from "react";
import { UitkLayoutGridItem, UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkText } from "uitk-react-text";

export interface DirectionLabelProps {
  colSpan: UitkLayoutConditionalGridSpan;
  locKey: string;
}

/**
 * Display direction From/To
 */
export const DirectionLabel: React.FC<DirectionLabelProps> = ({ colSpan, locKey }) => {
  const { formatText } = useLocalization();

  return (
    <UitkLayoutGridItem colSpan={colSpan}>
      <UitkText size={500} weight="bold">
        {formatText(locKey)}
      </UitkText>
    </UitkLayoutGridItem>
  );
};
